import { apiService } from '@shared/services/apiServices';
import type {
  AdminListServiceRequestsResponse,
  ListServiceRequestsParams,
} from '../types/serviceRequestListType';
import serviceRequestEndpoints from './serviceRequestEndpoints';

const EMPTY_RESPONSE: AdminListServiceRequestsResponse = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    totalCount: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

export const listAdminServiceRequestsApiService = {
  listServiceRequests: async (
    params?: ListServiceRequestsParams
  ): Promise<AdminListServiceRequestsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      queryParams.append('endDate', params.endDate);
    }

    const qs = queryParams.toString();
    const endpoint = `${serviceRequestEndpoints.SERVICE_REQUESTS}${qs ? `?${qs}` : ''}`;
    const response = await apiService.getAPI(endpoint);

    if (response.error) {
      return EMPTY_RESPONSE;
    }

    return response.data as AdminListServiceRequestsResponse;
  },
};
